const _ = require('lodash');
const $ = require('jquery');
require('bootstrap/js/dist/collapse');
const api = require('../../utils/api');
const selectOptions = require('../../utils/select-options');

const $document = $(document);

function initBrandModels(brandSelector, selector) {
    const brandInput = document.querySelector(brandSelector);
    const input = document.querySelector(selector);

    if (!brandInput || !input) {
        return;
    }

    const modelsRemote = brandInput.dataset.remote;


    const $brandInput = $(brandInput);
    const $modelInput = $(input);

    const cache = {};
    let currentRequest;

    $document.on('change', brandSelector, (event) => {
        if (currentRequest) {
            currentRequest.cancel();
            currentRequest = null;
        }

        const brand = $brandInput.val();

        if (!input.disabled) {
            selectOptions.clear(input);

            input.disabled = true;
        }

        if (!brand) {
            return;
        }

        const cacheKey = brand;

        if (cacheKey in cache) {
            modelsFetched(cache[cacheKey], input);

            input.disabled = false;

            return;
        }

        currentRequest = api.get(modelsRemote, {
            brand
        });

        currentRequest.then(({ data }) => {
            cache[cacheKey] = data;

            modelsFetched(data, input);

            input.disabled = false;
        }).catch(() => {}).finally(() => {
            currentRequest = null;
        });
    });


    const brand = $brandInput.val();

    if (brand) {
        cache[brand] = selectOptions.get(input, false);
    }
}

function modelsFetched(data, element) {
    selectOptions.clear(element);

    selectOptions.set(element, data);
}

function initSorting(sortingSelector, submit) {
    const sortingInput = document.querySelector(sortingSelector);

    if (!sortingInput || !sortingInput.name) {
        return;
    }

    let form = sortingInput.getAttribute('data-form');

    if (form) {
        form = document.getElementById(form);
    }

    if (!form) {
        return;
    }

    const targetInput = form.querySelector(`[name="${sortingInput.name}"]`);

    if (!targetInput) {
        return;
    }

    $document.on('change', sortingSelector, (event) => {
        targetInput.value = event.currentTarget.value;

        if (submit) {
            form.submit();
        }
    });
}

function init() {
    initBrandModels('#brand', '#model');

    initSorting('#sorting', true);
}

export { init };
